import { getLogger } from '../../diagnostics/logger';
import moment from 'moment';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { ENSURE_AVAILABLE_TELS, INITIAL_AUTHENTICATION, LOAD_AVAILABLE_TELS } from '../../actions/actionTypes';
import {
  loadAvailableTelsFailure,
  loadAvailableTelsPending,
  loadAvailableTelsSuccess,
} from '../../actions/availableTelActions';
import { Action, PromiseAction } from '../../actions/commonActions';
import * as simProvisionApi from '../../api/simProvisionApi';
import { LoadTelsFilter } from '../../models/AvailableTels';
import { AvailableTelsState } from '../../models/state/availableTelsState';
import { selectAvailableTels } from '../../selectors/availableTels';

/*
 * A saga which fetches the list of available tels.
 */
export function* loadAvailableTelsSaga(action: PromiseAction<LoadTelsFilter, {}>) {
  const { payload } = action;
  if (!payload) {
    return;
  }

  const { accountId, networkId } = payload;
  yield put(loadAvailableTelsPending(payload));
  try {
    const itemsFromApi: string[] = yield call(simProvisionApi.getAvailableTels, accountId, networkId);

    const response = {
      filter: payload,
      tels: itemsFromApi,
    };

    yield put(loadAvailableTelsSuccess(response));

    action.resolve && action.resolve(response);
  } catch (error: any) {
    yield put(loadAvailableTelsFailure(payload, error));
    console.error(error);
  }
}

/*
 * A saga which fetches the list of available tels if needed
 */
export function* ensureAvailableTelsSaga(action: Action<LoadTelsFilter>) {
  const payload = action.payload;
  if (!payload) {
    return;
  }

  const state: AvailableTelsState = yield select(selectAvailableTels);
  const { accountId, networkId } = state.filter;
  if (
    accountId !== payload.accountId ||
    networkId !== payload.networkId ||
    (state.expiresOn && state.expiresOn < moment().toDate())
  ) {
    yield call(loadAvailableTelsSaga, action);
  }
}

/*
 * Initializes all sagas that are related to available tels.
 */
export function* initAvailableTelsSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(LOAD_AVAILABLE_TELS, loadAvailableTelsSaga);
  yield takeEvery(ENSURE_AVAILABLE_TELS, ensureAvailableTelsSaga);
}
